// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.processing-title[data-v-03b2d386] {\n  display: flex;\n  justify-content: start;\n  margin-bottom: 20px;\n}\n.processing-title p[data-v-03b2d386] {\n  font-size: 16px !important;\n  font-weight: 500;\n}\n.process-timeline .process-timeline-title[data-v-03b2d386] {\n  font-size: 14px;\n}\n.process-timeline .process-timeline-time[data-v-03b2d386] {\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
